import { render } from "./SheetContent.vue?vue&type=template&id=13c27460&ts=true"
import script from "./SheetContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13c27460"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13c27460', __exports__)) {
    api.reload('13c27460', __exports__)
  }
  
  module.hot.accept("./SheetContent.vue?vue&type=template&id=13c27460&ts=true", () => {
    api.rerender('13c27460', render)
  })

}


export default __exports__